export enum CamposAdicionalesEnum {
	EsTurismoAventura = 3,
	AplicaPropiedadHorizontal = 6,
	TieneAutorizacionPropiedadHorizontal = 7,
	RelacionarVehiculos = 8
}
